import { Collaborator } from '@models/collaborator';
// import { Alert } from '@models/alert';

export class Activity {

    public constructor(init?: Partial<Activity>) {
        Object.assign(this, init);
    }

    id: number;
    requirementid: number;
    created_by: number;
    subject: string;
    content: string;
    date_activity: any;
    hour_activity: any;
    /** ISO 8601 UTC: fecha+hora del formulario en reloj del navegador (localWallClockToIsoUtc). */
    activity_at?: string | null;
    idsCollaborators: any;
    alerts: any;
    activities: any;
    collaborators: any;

}

export class ActivityContract {

    public constructor(init?: Partial<Activity>) {
        Object.assign(this, init);
    }

    id: number;
    contractid: number;
    subject: string;
    text: string;
    date: any;
    hour_activity: any;
    users = [];
    created_by: number;
    idsCollaborators: any;
    alerts: any;
    activities: any;
    activity:any;
    collaborators: any;

}